import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
   
       
        <p className="footer-text">    <i className="fas fa-phone-alt"></i> 053-313-463 | <i className="fas fa-envelope"></i> <a href="mailto:sarirom@gmail.com">sarirom@gmail.com</a></p>
   
    </footer>
  );
};

export default Footer;